<template>
  <div class="container">
    <b-alert show variant="danger">{{ i18n.error404 }}</b-alert>
  </div>
</template>

<script>
import BAlert from 'bootstrap-vue';
export default {
  components: {
    BAlert,
  },
  data: function() {
    return {
      i18n: {
        error404: this.$t(`error404`),
      },
    };
  },
};
</script>
